import React from 'react';
import AdditionalPatientsComponent from '~/components/AdditionalPatients';

export default () => {
  return {
    chunks: ['additionalPatients'],

    component: <AdditionalPatientsComponent />,
    accountWrapper: {
      loginRequired: false,
      nonBlocking: true,
    },
  };
};

if (module.hot) {
  module.hot.accept();
}
